import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property, queryAssignedNodes } from 'lit/decorators.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import styles from './heading-list.scss.js';
/**
 * @element cipublic-heading-list
 */
export class HeadingList extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * Heading list color.
         */
        this.color = 'primary';
        this.emitConnectedCallback = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.emitConnectedCallback) {
            emit(this, 'connected-callback');
        }
    }
    updateCounter() {
        var _a, _b;
        for (let i = 0; i <= this.listItems.length; i += 1) {
            const element = (_b = (_a = this.listItems[i]) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.counter');
            if (element) {
                element.innerHTML = String(i + 1);
            }
        }
    }
    render() {
        return html `<ol><slot name="item" @slotchange="${this.updateCounter}"></slot></ol>`;
    }
}
HeadingList.styles = styles;
__decorate([
    property({ reflect: true })
], HeadingList.prototype, "color", void 0);
__decorate([
    queryAssignedNodes('item', true)
], HeadingList.prototype, "listItems", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], HeadingList.prototype, "emitConnectedCallback", void 0);
//# sourceMappingURL=heading-list.js.map